package com.hyperether.goodjob.repository.remote.model

import com.hyperether.goodjob.models.UserTeam
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class UserRequest(
    @SerialName("fullName") val fullName: String,
    @SerialName("role") val role: String,
    @SerialName("email") val email: String,
    @SerialName("phone") val phone: String,
    @SerialName("zip") val zip: String,
    @SerialName("country") val country: String,
    @SerialName("city") val city: String,
    @SerialName("address") val address: String,
    @SerialName("status") val status: String,
    @SerialName("workspaceId") val workspaceId: String,
    @SerialName("skils") val skills: List<String>,
    @SerialName("teams") val teams: List<UserTeam>,
    @SerialName("upcomingLeave") val upcomingLeave: String? = null,
    @SerialName("workingHours") var workingHours: WorkingHours? = null,
    @SerialName("pendingPlanId") var pendingPlanId: String? = null,
    @SerialName("subscriptionEndsAt") var subscriptionEndsAt: Long? = null,
    @SerialName("pushToken") var pushToken: String? = null,
    @SerialName("lang") var lang: String? = null
)